import { render } from "./AppLink.vue?vue&type=template&id=70f2d162&scoped=true&ts=true"
import script from "./AppLink.vue?vue&type=script&lang=ts"
export * from "./AppLink.vue?vue&type=script&lang=ts"

import "./AppLink.vue?vue&type=style&index=0&id=70f2d162&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f2d162"]])

export default __exports__